(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tasting-notes"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('[data-tasting-notes-section]');

    sections.forEach(function (section) {
      var cards = section.querySelectorAll('.tasting-note-card');

      /* Existing per-card read more/less behavior */
      cards.forEach(function (card) {
        var body = card.querySelector('[data-tasting-note-body]');
        var toggle = card.querySelector('[data-tasting-note-toggle]');

        if (!body || !toggle) return;

        var labelMore = toggle.getAttribute('data-label-more') || 'Read more';
        var labelLess = toggle.getAttribute('data-label-less') || 'Read less';

        var isOverflowing = body.scrollHeight > body.clientHeight;
        if (!isOverflowing) {
          toggle.style.display = 'none';
          return;
        }

        toggle.addEventListener('click', function () {
          var isExpanded = card.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          toggle.textContent = isExpanded ? labelLess : labelMore;
        });
      });

      /* New Show all / Show less behavior for cards after the 4th */
      var toggleAll = section.querySelector('[data-tasting-notes-toggle-all]');
      if (!toggleAll) return;

      var hiddenCards = section.querySelectorAll('[data-tasting-note-hidden]');
      if (!hiddenCards.length) return;

      var labelShowAll = toggleAll.getAttribute('data-label-show-all') || 'Show all';
      var labelShowLess = toggleAll.getAttribute('data-label-show-less') || 'Show less';

      toggleAll.addEventListener('click', function () {
        var isExpanded = toggleAll.getAttribute('aria-expanded') === 'true';
        var nextExpanded = !isExpanded;

        hiddenCards.forEach(function (card) {
          if (nextExpanded) {
            card.classList.remove('tasting-note-card--hidden');
          } else {
            card.classList.add('tasting-note-card--hidden');
          }
        });

        toggleAll.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        toggleAll.textContent = nextExpanded ? labelShowLess : labelShowAll;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
